import React, { useState } from "react";

const Booking = () => {
  const [step, setStep] = useState(1);
  const todayDate = new Date();
  const [selectedDay, setSelectedDay] = useState(todayDate.getDate());


  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();

  const dateNames = [
    "SUNDAY",
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
  ];

  const monthName = new Date(currentYear, currentMonth).toLocaleString(
    "default",
    { month: "long" }
  );

  function getOrdinal(n) {
    let s = ["th", "st", "nd", "rd"],
      v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }
  const handleDayClick = (day) => {
    const selected = new Date(currentYear, currentMonth, day);
    const startOfToday = new Date();

    startOfToday.setHours(0, 0, 0, 0);
    selected.setHours(0, 0, 0, 0);

    if (selected < startOfToday) return;

    setSelectedDay(day);
  };

  const getDayName = (dayNum) => {
    const dayIndex = (1 + dayNum) % 7;
    return dateNames[dayIndex];
  };

  const getDayString = (dayNum) => {
    return dayNum < 10 ? "0" + dayNum : dayNum;
  };

  // ✅ EMAIL VALIDATION
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  // ✅ PHONE VALIDATION (simple international-safe)
  const validatePhone = (phone) => {
    const re = /^[0-9+\s-]{7,15}$/;
    return re.test(phone);
  };

  const handleNextStep = (nextStep) => {
    if (nextStep === 3) {
      const name = document.getElementById("fname")?.value?.trim();
      const email = document.getElementById("femail")?.value?.trim();
      const phone = document.getElementById("fphone")?.value?.trim();

      if (!name || !email || !phone) {
        alert("Please fill all fields.");
        return;
      }

      if (!validateEmail(email)) {
        alert("Please enter a valid email address.");
        return;
      }

      if (!validatePhone(phone)) {
        alert("Please enter a valid phone number.");
        return;
      }
    }

    setStep(nextStep);
  };

  const handleBackStep = () => {
    setStep((prev) => Math.max(1, prev - 1));
  };

  const currentDayName = getDayName(selectedDay);
  const currentDayNumString = getDayString(selectedDay);

  const shortName =
    currentDayName.charAt(0) +
    currentDayName.slice(1).toLowerCase().substring(0, 2);

  const leftDateDisplay = `${shortName}, ${getOrdinal(
    selectedDay
  )} ${monthName}`;

  const renderCalendar = () => {
    const daysArr = ["S", "M", "T", "W", "T", "F", "S"];
    const squares = [];

    // headers
    daysArr.forEach((d, idx) => {
      squares.push(
        <div key={`header-${idx}`} className="cal-header">
          {d}
        </div>
      );
    });

    const firstDay = new Date(currentYear, currentMonth, 1).getDay();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    for (let i = 0; i < firstDay; i++) {
      squares.push(<div key={`empty-${i}`} className="cal-day empty"></div>);
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(currentYear, currentMonth, i);
      date.setHours(0, 0, 0, 0);

      const isPast = date < today;

      squares.push(
        <div
          key={`day-${i}`}
          className={`cal-day ${selectedDay === i ? "active" : ""} ${isPast ? "disabled" : ""
            }`}
          onClick={() => !isPast && handleDayClick(i)}
        >
          {i}
        </div>
      );
    }

    return squares;
  };

  return (
    <>
      <section className="inner-banner">
        <img src="/images/inner-banner.png" alt="" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner-banner-text">
                <img src="/images/robort1.png" alt="" className="robort1" />
                <img src="/images/robort2.png" alt="" className="robort2" />
                <h1>
                  Schedule <span>Demo</span>
                </h1>
                <div className="store-links">
                  <a href="#">
                    <img src="/images/app-img1.png" alt="App Store" />
                  </a>
                  <a href="#">
                    <img src="/images/app-img2.png" alt="Google Play" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="booking-wrap">
        <img src="/images/booking-img.png" alt="" />
        <div className="container-fluid" id="booking-app">
          <div className="row g-4 align-items-stretch">
            {/* LEFT PANEL */}
            <div className="col-md-6">
              <div className="panel h-100" id="left-panel">
                <div className="brand-logo">
                  <img src="/images/logo.png" />
                </div>

                <h2 className="fw-bold text-white mt-4 mb-2 meeting-title">
                  30 Minute Meeting
                </h2>

                <div id="left-date-display" className="text-white mt-1">

                  <p className="m-0 mt-1">
                    <i className="fa-regular fa-clock"></i> 30 Mint
                  </p>
                </div>

                {/* ✅ VIDEO KEPT EXACTLY AS IT WAS */}
                <div className="illus-container">
                  <img src="/images/booking-illustration.png" alt="" />
                  <video
                    loop
                    autoPlay
                    muted
                    src="/images/onboarding.mp4"
                  ></video>
                </div>
              </div>
            </div>

            {/* RIGHT PANEL */}
            <div className="col-md-6">
              <div className="panel h-100" id="right-panel">

                {/* STEP 1 */}
                <div className={`step-panel ${step === 1 ? "active" : ""}`}>

                  <div className="d-flex justify-content-between mb-1">
                    <div className="time-book">
                      <h5 className="m-0 text-white fw-semibold step-title">
                        Select a Date & Time
                      </h5>
                      <p><i className="fa-regular fa-clock"></i> 30 Mint</p>
                    </div>

                    {/* desktop button */}
                    <button
                      className="btn-light-custom d-none d-md-inline-block"
                      onClick={() => handleNextStep(2)}
                    >
                      Next
                    </button>
                  </div>

                  <div className="cal-wrapper">
                    <div className="cal-left">
                      <div className="fw-bold mb-1 day-name-display">
                        {currentDayName}
                      </div>
                      <div className="text-white mb-1 month-name-display">
                        {monthName}
                      </div>
                      <div className="fw-bold text-white lh-1 mt-1 day-num-display">
                        {currentDayNumString}
                      </div>
                    </div>

                    <div className="cal-right">{renderCalendar()}</div>
                  </div>

                  {/* mobile bottom button */}
                  <div className="mobile-step-actions d-md-none">
                    <button
                      className="btn-light-custom w-100"
                      onClick={() => handleNextStep(2)}
                    >
                      Next
                    </button>
                  </div>

                </div>

                {/* STEP 2 */}
                <div className={`step-panel ${step === 2 ? "active" : ""}`}>

                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <button
                      className="d-none d-md-inline-block back-btn"
                      onClick={handleBackStep}
                    >
                     <i class="fa-solid fa-arrow-left"></i>
                    </button>
                  </div>

                  <h5 className="text-white fw-semibold step-title mb-3">
                    Fill The Form Below:
                  </h5>

                  <form
                    className="booking-form"
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleNextStep(3);
                    }}
                  >
                    <div className="mb-3">
                      <input type="text" className="form-control" placeholder="Name" id="fname" required />
                    </div>

                    <div className="mb-3">
                      <input type="email" className="form-control" placeholder="Email" id="femail" required />
                    </div>

                    <div className="mb-3">
                      <input type="tel" className="form-control" placeholder="Phone" id="fphone" required />
                    </div>

                    <div className="d-flex justify-content-end pt-3 d-none d-md-flex">
                      <button type="submit" className="btn-light-custom">
                        Submit
                      </button>
                    </div>
                  </form>

                  {/* mobile bottom buttons */}
                  <div className="mobile-step-actions d-md-none">
                    <button className="btn-light-custom w-50" onClick={handleBackStep}>
                      Back
                    </button>

                    <button className="btn-light-custom w-50" onClick={(e) => {
                      e.preventDefault();
                      handleNextStep(3);
                    }}>
                      Submit
                    </button>
                  </div>

                </div>

                {/* STEP 3 */}
                <div className={`step-panel ${step === 3 ? "active" : ""}`}>
                  <div className="text-center done-text d-flex flex-column justify-content-center align-items-center h-100 w-100 pb-4">
                    <img src="/images/robort1.png" />
                    <h3>Done</h3>
                    <p>The details had been sent to your inbox.</p>

                    <button className="btn-light-custom mt-3" onClick={handleBackStep}>
                      Back
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Booking;